import { Users, Globe, Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { League } from '@/types/game';

interface LeaguesListProps {
  leagues: League[];
}

export function LeaguesList({ leagues }: LeaguesListProps) {
  const navigate = useNavigate();

  if (leagues.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground mb-4">You haven't joined any leagues yet.</p>
        <Button onClick={() => navigate('/leagues')}>Browse Leagues</Button>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {leagues.map((league) => (
        <div
          key={league.id}
          className="game-card cursor-pointer hover:border-primary/50 transition-colors"
          onClick={() => navigate(`/leagues/${league.id}`)}
        >
          <div className="flex items-center gap-4">
            <div className="p-3 rounded-full bg-primary/20">
              <Users className="w-5 h-5 text-primary" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <h3 className="font-semibold">{league.name}</h3>
                {league.is_public ? (
                  <Globe className="w-4 h-4 text-muted-foreground" />
                ) : (
                  <Lock className="w-4 h-4 text-muted-foreground" />
                )}
              </div>
              {league.description && (
                <p className="text-sm text-muted-foreground line-clamp-1">{league.description}</p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}